import { post} from "./index";
import *as utils from '../utils'
import moment from 'moment'
import {applicationName} from "../utils";

export function formateData(data) {
    if(!data)
        return {};
    const result = Object.entries(data).map(([key, value]) =>
        key+'='+value).join('&');
    return result;
}

const headers = {
    "Pragma": 'no-cache',
    'Cache-Control': 'no-cache',
    'Content-Type': ' application/x-www-form-urlencoded; charset=UTF-8',
};

export const get = (url,param, callBack) => {

    //fetch请求
    fetch(encodeURI(url+utils.params(param)), {
        method: 'GET',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        // alert(error)
    })
}

//查询项目列表
export const getProjectList =(param, callBack) => {
   get("/cm-sites-" + applicationName()+`/interviewEvent/list`,{time: new Date().getTime(),...param}, callBack)
}


//新建项目
export const addProject = (param, callBack) => {
   post("/cm-sites-" + applicationName()+`/interviewEvent/add?time=${new Date().getTime()}`, param, callBack)  
}

//编辑项目
export const editProject = (param, callBack) => {
    post("/cm-sites-" + applicationName()+`/interviewEvent/edit?time=${new Date().getTime()}`, param, callBack)

}

//删除项目
export const delProject = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/interviewEvent/deleteById`, {time: new Date().getTime(),...param}, callBack)
   
}

//  根据id查询平台详细信息
export const getPlatformInfo = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/media/getMediaByIds`, {time: new Date().getTime(),...param}, callBack)
}


// 根据id查附件详细信息
export const getAttachmentInfo = (attachmentIds)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+`/interview/getAttachmentFiles?time=${new Date().getTime()}`;
    let params = {
        attachmentIds
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        traditional: true,//参数中有数组，防止深度序列化
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject(e);
        }
    });
})


//项目任务列表
export const getTaskList = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/interviewEvent/getInterviewByInterviewEventId`,{time: new Date().getTime(),...param}, callBack);
};

//删除项目任务
export const deleteTaskById = ( param, callBack )=>{
    post("/cm-sites-"+applicationName() +`/interview/removeInterviewFromInterviewEvent?time=${new Date().getTime()}`,param,callBack);
}


//关联任务  任务列表

export const getRelateTaskList = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/interviewEvent/getNotBindingInterviews`,{time: new Date().getTime(),...param}, callBack);
}

// 关联任务

export const confirmRelateTask = (param, callBack) => {
    post("/cm-sites-"+applicationName() +`/interviewEvent/bindingInterviews?time=${new Date().getTime()}`,param,callBack);

}

//项目的稿件列表
export const manuscriptList = (param, callBack) => {
    let url = "/cm-sites-" + applicationName()+`/interviewEvent/getResourceByInterviewEventId?currentTime=${moment().unix()}`;
    if(param.url){
        url = param.url;
    }else {
        delete param.url
    }
    post(url,param, callBack);
    
}

//下载单个稿件
export const getZipPath = (param, callBack) => {
    fetch("/cm-sites-" + applicationName()+`/zyk/download/downloadStorys`, {
        method: 'post',
        cache: 'no-cache',
        body: formateData(param),
        headers: headers,
        credentials: 'include'
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
         alert(error)
    })
}


//下载所有稿件
export const getAllZipPath = (param, callBack) => {
    let url = "/cm-sites-" + applicationName()+`/zyk/download/downloadInterviewEventAllStorys`
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        body: formateData(param),
        credentials: 'include'
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
         alert(error)
    })
}

export const download = (param, callBack) => {
    let url = "/cm-sites-"+applicationName() +`/zyk/download/downloadResourceFile?` + param;
    callBack(url);
}

//导出稿件列表
export const exportManuscriptList = (param, callBack) => {
    let url = "/cm-sites-"+applicationName() +"/excelExport/exportInterviewEventAllStory?" + param;
    callBack(url);
}

//项目的任务图片列表
export const taskPictureList = (param, callBack) => {
    post("/cm-sites-" + applicationName()+`/interviewEvent/getInterviewResourceByInterviewEventId?time=${new Date().getTime()}`,param, callBack);
}

//项目的任务视频列表
export const taskVideoList = (param,  callBack) => {
    post("/cm-sites-" + applicationName()+`/interviewEvent/getInterviewResourceByInterviewEventId?time=${new Date().getTime()}`,param, callBack);
}


//项目的美工附件列表
export const getattachmentList = (param, callBack) => {
    post("/cm-sites-" + applicationName()+`/interviewEvent/getInterviewResourceByInterviewEventId`,param, callBack);
}

/**
 * 根据id获取项目信息
 * @param id
 * @returns {Promise<any>}
 */
export const getProjectById = (id)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/interviewEvent/getById";
    let params = {
        id
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
})

